import React from "react";
import InfoItem from "../InfoItem/InfoItem";
import {
  checkEmptyObj,
  convertIosStringToDateDayjs,
  moveElementToEnd,
} from "helper/common";
import {Divider, Space} from "antd";
import dayjs from "dayjs";
import {FORMAT_TIME} from "types/enums";

const Intraocular = props => {
  const {data, isShow = true} = props;

  const render = () => {
    return (
      <>
        {isShow && <div className="title">Nhãn áp:</div>}
        <Space direction="vertical">
          {moveElementToEnd(
            Object.keys(data || {}).filter(key => data[key] && key != "show"),
            "Ghi chú"
          ).map(key => {
            if (key == "formList") {
              return (
                <div>
                  {data[key]
                    ?.sort((a, b) =>
                      convertIosStringToDateDayjs(
                        a?.min,
                        FORMAT_TIME.dateTime
                      )?.diff(
                        convertIosStringToDateDayjs(
                          b?.min,
                          FORMAT_TIME.dateTime
                        )
                      )
                    )
                    ?.filter(item => item?.mmHg || item?.mmHG == 0)
                    .map((e, index) => {
                      return (
                        <>
                          {(e?.mmHg || e?.mmHG == 0) && (
                            <div>
                              <span>Lần đo {index + 1}</span>:{" "}
                              <span>{e?.mmHg} mmHg</span>
                              <span>
                                {" "}
                                {e?.method ? `- Phương pháp ${e?.method}` : ""}
                              </span>
                            </div>
                          )}
                        </>
                      );
                    })}
                </div>
              );
            } else if (key == "Comment") {
              return <InfoItem label="Ghi chú" value={data[key]} />;
            }
          })}
        </Space>
        <Divider className="border-grey"></Divider>
      </>
    );
  };
  return <div className="Intraocular">{!checkEmptyObj(data) && render()}</div>;
};
export default Intraocular;
